import { Button } from '@mantine/core';
import { $a, handleDrop } from 'shared-base';
import { IUser } from '../../types';
import AssetPackList from '../AssetPackList/AssetPackList';
import IconButton from '../IconButton/IconButton';
import { Top, Wrapper } from './NavBarEditor.style';

export type NavBarEditorProps = {
  data: {
    user: IUser;
    models: IModel[];
    isLoading: boolean;
    projectType: ProjectType;
  };
  callbacks: {
    onNavigate: (path: string) => void;
    onAction: OnAction;
  };
};

export function NavBarEditor(props: NavBarEditorProps) {
  const { data, callbacks } = props;
  const { projectType, models } = data;

  function onBack() {
    callbacks.onNavigate('/projects');
  }

  function allowDrop(ev: React.DragEvent) {
    ev.preventDefault();
  }

  async function onDrop(ev: React.DragEvent) {
    ev.preventDefault();

    const json = await handleDrop(ev);
    if (!json) return;
    callbacks.onAction($a('MODELS', 'jsonDropped', '', { json }));
    return false;
  }

  function renderNewModel() {
    if (projectType === 'scene') return null;

    return (
      <Button
        onClick={() => callbacks.onAction($a('MODELS', 'new'))}
        color='pink'
        variant='outline'
        fullWidth
      >
        New Model
      </Button>
    );
  }

  return (
    <Wrapper
      className='NavBarEditor-wrapper'
      data-testid='NavBarEditor-wrapper'
      onDragOver={allowDrop}
      onDrop={onDrop}
    >
      <Top>
        <IconButton onClick={onBack} name='IconArrowLeft' />
        {renderNewModel()}
      </Top>
      <AssetPackList
        models={models}
        onAction={callbacks.onAction}
        onPick={(id) => callbacks.onAction($a('MODELS', 'pick', id))}
        onNew={() => callbacks.onAction($a('MODELS', 'new'))}
      />
    </Wrapper>
  );
}

export default NavBarEditor;
